var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-row"},[_c('div',{staticClass:"page-row__side page-row__side_left"},[_vm._t("default")],2),_c('div',{staticClass:"page-row__side page-row__side_right"},[_vm._t("right-side")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }